// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FgC4","colMin":"styles_colMin__1RMvs"};